export const enumerationToLabel =
  (labelKey: string) =>
  (enumeration: Enumeration): string =>
    enumeration?.[labelKey] ?? '';

export const sortAndMapEnumerationToLabel = (
  enumerations: Enumeration[],
  labelKey = 'label',
): string[] =>
  (enumerations ?? [])
    .map(enumerationToLabel(labelKey))
    .sort((a, b) => a.localeCompare(b));
